import React from "react";
import { Box, Card, Flex, Link, Text } from "rebass";

import { SubmitButton } from "../../forms/components/SubmitButton";

interface IProps {
  header: string;
  href: string;
  message: string;
  title: string;
}

export function LinkWithMassage({ header, title, href, message }: IProps) {
  return (
    <Flex
      height="100%"
      flexDirection="column"
      p="65px 100px 35px"
    >
      <Text
        as="h3"
        color="#2b3160"
        fontSize="30px"
        fontWeight="bold"
        lineHeight={1.07}
      >
        {header}
      </Text>

      <Card
        as="p"
        mt="40px"
        p="14px 25px"
        borderRadius="5px"
        color="wild-blue"
        backgroundColor="#fff"
        boxShadow="0 3px 29px 0 rgba(0,0,0,0.23)"
      >
        {message}
      </Card>

      <Box mt="20px">
        <SubmitButton
          as={Link}
          href={href}
          target="_blank"
        >
          {title}
        </SubmitButton>
      </Box>
    </Flex>
  );
}
